import { useState, useEffect } from "react";
import axios from "axios";
import { SERVICEURL } from "../../appconfig";

export interface AiPosition {
  positionId: string;
  positionName: string;
  workingModel: string;
  client: string;
  techGroupNames: string[];
  matchScore: number;
  justification?: string;
  explanation?: string;
  team?: string;
}

const CHUNK_SIZE = 100;
const MIN_MATCH_SCORE = 40;

interface UseAiSuggestedPositionsReturn {
  positions: AiPosition[];
  totalCount: number;
  loading: boolean;
  hasFetched: boolean;
  resetCache: () => void;
  fetch: () => void;
}

export const useAiSuggestedPositions = (
  talentId?: string,
  enabled = true,
): UseAiSuggestedPositionsReturn => {
  const [positions, setPositions] = useState<AiPosition[]>([]);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [hasFetched, setHasFetched] = useState(false);

  // Reset cache when talentId changes
  useEffect(() => {
    setHasFetched(false);
    setPositions([]);
    setTotalCount(0);
  }, [talentId]);

  const fetchPositions = async () => {
    if (talentId === undefined) return;

    if (!talentId) {
      setPositions([]);
      setTotalCount(0);
      setLoading(false);
      return;
    }

    if (!enabled || hasFetched) return;

    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      const response = await axios.post(
        `${SERVICEURL}api/InterviewAssistant/SearchPositionAIForCandidateAsync`,
        {
          talentId,
          page: 0,
          pageSize: CHUNK_SIZE,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      console.log(response);

      if (response.data?.data.data) {
        const fetchedData: AiPosition[] = (response.data.data.data || []).map(
          (item: any) => ({
            positionId: String(item.positionId ?? item.PositionId ?? ""),
            positionName: item.positionName ?? item.PositionName ?? "",
            workingModel: item.workingModel ?? item.WorkingModel ?? "",
            client: item.client ?? item.Client ?? "",
            techGroupNames: item.techGroupNames ?? item.TechGroupNames ?? [],
            matchScore: item.matchScore ?? item.MatchScore ?? 0,
            justification:
              item.justification ??
              item.aiJustification ??
              item.Justification ??
              "",
            explanation:
              item.explanation ?? item.aiExplanation ?? item.Explanation ?? "",
            team: item.team ?? item.Team ?? "",
          }),
        );
        const filtered = fetchedData.filter(
          (item) => item.matchScore >= MIN_MATCH_SCORE,
        );
        console.log(fetchedData);
        console.log(filtered);

        setPositions(filtered);
        setTotalCount(filtered.length);
        setHasFetched(true);
      }
    } catch (error) {
      console.error("AI pozisyon fetch error:", error);
      setPositions([]);
      setTotalCount(0);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPositions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [talentId, enabled, hasFetched]);

  const resetCache = () => {
    setHasFetched(false);
    setPositions([]);
    setTotalCount(0);
  };

  return {
    positions,
    totalCount,
    loading,
    hasFetched,
    resetCache,
    fetch: fetchPositions,
  };
};
